/** @file selectAt: left-click selection in the viewport (Shift toggles, a click on nothing clears). */
import { nodeAt } from './nodeAt';
import { quadAt } from './quadAt';
import type { ViewportCtx } from './viewportCtx';

/**
 * Selects the joint under `p` (target pixels); with `add` it toggles that joint in the selection instead. With the
 * quads view on, a click on a part's picture selects that drawable too.
 */
export function selectAt(ctx: ViewportCtx, p: [number, number], add: boolean): void {
  const s = ctx.store.getState();
  const joint = nodeAt(ctx, p);
  if (joint === null) {
    if (!add) s.select({ nodes: [] });
    return;
  }
  const has = s.selection.nodes.includes(joint.name);
  // the quads view: a click on a part's picture also selects that part (its quad gets the handles)
  const part = s.camera.quads ? ctx.puppet()?.bundle.puppet.drawables[quadAt(ctx, p)] : undefined;
  if (part !== undefined && part.node === joint.name) s.select({ drawable: part.id });
  if (!add) s.select({ nodes: [joint.name] });
  else s.select({ nodes: has ? s.selection.nodes.filter((n) => n !== joint.name) : [...s.selection.nodes, joint.name] });
}
